module.exports = __webpack_public_path__ + "media/images/emblems/Billens-coat_of_arms-30f32de98855bc8f5115abfdf4efc613.svg";